<template>
  <router-link :to="route" class="link-to-post">
    <slot></slot>
  </router-link>
</template>

<script>

import { getPostRoute } from '@/router/helper';

export default {
  name: 'link-to-post',
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      route: {
        name: '',
      },
    };
  },
  watch: {
    post: {
      handler: 'updateRoute',
      immediate: true,
    },
  },
  methods: {
    updateRoute(post) {
      this.route = getPostRoute(post);
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/LinkToPost.vue